export const ANALYSIS_SECTION_TITLES = {
  overview: {
    description: "Description",
    authors: "Authors",
    total_queries: "Total Queries",
    tables_used: "Tables Used",
  },
};
